import React, { useContext } from 'react';
import styled from 'styled-components';
import { Button, Link, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { storeContext } from '../../context';
import { t } from '../../../utils/i18next';

const StyledDiv = styled.div`
  margin-left: 3rem;
  flex: 1 0 auto;
  a {
    margin: 1rem;
    font-weight: 400;
  }
  .logoutButton {
    text-transform: none;
    font-size: 1.3rem;
    width: auto;
    display: inline-block;
    padding: 0;
    cursor: pointer;
    &:hover {
      background-color: unset;
      text-decoration: underline;
    }
  }
`;

const HelpAndLogout = observer(() => {
  const {
    providerLinks: { helpLink, logoutLink },
    session: { logout },
    settings
  } = useContext(storeContext);

  const logoutByPatientGw = settings.get('SUS_1645_logout');

  return (
    <StyledDiv id={'helpAndLogout'} data-testid={'help-and-logout'}>
      <div className={'buttonsWrapper'} id={'buttons-wrapper'}>
        <Typography color={'secondary'}>
          {helpLink && (
            <>
              <a
                href={helpLink}
                target="_blank"
                rel="noopener noreferrer"
                tabIndex={0}
                id={'helpLink'}
                data-testid={'helpLink'}
              >
                {t('account.help')}
              </a>
              |
            </>
          )}
          {(logoutLink || logoutByPatientGw) && (
            <Link
              onClick={logoutByPatientGw ? logout : undefined}
              href={!logoutByPatientGw ? logoutLink : undefined}
              rel="noopener noreferrer"
              tabIndex={0}
              id={'logoutLink'}
              className={'logoutButton'}
              data-testid={'logoutLink'}
              variant={'text'}
              color={'secondary'}
            >
              {t('account.sign_out')}
            </Link>
          )}
        </Typography>
      </div>
    </StyledDiv>
  );
});

export default HelpAndLogout;
